import React from 'react'
import { Typography } from '@ann/web-components'
import { MyDriveDetailContent, LoadingContainer, CircularProgress } from '../../pages/MyDrivePage/MyDrivePage.styled'
import SlideoutDocumentCard from '../../../SlideoutDocumentCard'
import SearchResults from '../SearchResults/SearchResults'

const DocumentList = ({
    documents,
    onDocumentSelection,
    selectedDocuments,
    isLoading,
    searchQuery,
    selectedDriveTitle,
    selectedDriveOwner
}) => {
    if (isLoading) {
        return (
            <LoadingContainer>
                <CircularProgress />
            </LoadingContainer>
        )
    }

    return (
        <>
            <Typography category="body" size="medium" weight="regular">
                Drive / {selectedDriveTitle}
            </Typography>

            {searchQuery && (
                <SearchResults
                    searchQuery={searchQuery}
                    count={documents.length}
                    type="document"
                />
            )}

            <MyDriveDetailContent>
                {documents.map((document) => (
                    <SlideoutDocumentCard
                        key={document.name}
                        id={document.name}
                        title={document.name}
                        description={document.description}
                        ownerName={selectedDriveOwner}
                        lock={'89'}
                        version={'Version 1.3.2'}
                        checked={selectedDocuments.includes(document.uuid)}
                        onChange={() => onDocumentSelection(document.uuid)}
                    />
                ))}
            </MyDriveDetailContent>
        </>
    )
}

export default DocumentList

